import { CropConnectRoleDefinitions } from '../../cropConnectApiClient';
import { SecurityTrimMode, SecurityTrimProps } from '../SecurityTrim';

export const sideBarAdministrationPathSecurityTrimProps: SecurityTrimProps = {
  requiredBusinessPartnerRoles: [CropConnectRoleDefinitions.ServiceProvider],
  requiredGlobalRoles: [
    CropConnectRoleDefinitions.GlobalAdmin,
    CropConnectRoleDefinitions.DeliveryPlanAdmin,
    CropConnectRoleDefinitions.RedCertAdmin,
  ],
  //onlyNordzuckerInternalUsers: true,
  securityTrimMode: SecurityTrimMode.OR,
};
